import { createSlice } from "@reduxjs/toolkit";
import { getDelegateStock, adjustStock, importStock, getStockHistory } from "./stocksThunk";

const initialState = {
  currentStock: {
    data: [],
    loading: false,
    error: null,
  },
  adjustment: {
    loading: false,
    success: false,
    error: null,
  },
  importState: {
    loading: false,
    success: false,
    error: null,
    data: null, // Ajout de data pour stocker le rapport (successCount, errors)
  },
  history: { data: [], loading: false, error: null }
};

const stocksSlice = createSlice({
  name: "stocks",
  initialState,
  reducers: {
    resetAdjustmentState: (state) => {
      state.adjustment.loading = false;
      state.adjustment.success = false;
      state.adjustment.error = null;
    },
    resetImportState: (state) => {
      state.importState.loading = false;
      state.importState.success = false;
      state.importState.error = null;
      state.importState.data = null; // Reset du rapport
    },
    resetHistory: (state) => {
      state.history.data = [];
      state.history.loading = false;
    }
  },
  extraReducers: (builder) => {
    // GET STOCK
    builder
      .addCase(getDelegateStock.pending, (state) => {
        state.currentStock.loading = true;
        state.currentStock.error = null;
      })
      .addCase(getDelegateStock.fulfilled, (state, action) => {
        state.currentStock.loading = false;
        state.currentStock.data = action.payload;
      })
      .addCase(getDelegateStock.rejected, (state, action) => {
        state.currentStock.loading = false;
        state.currentStock.error = action.payload;
      });

    // ADJUST STOCK
    builder
      .addCase(adjustStock.pending, (state) => {
        state.adjustment.loading = true;
        state.adjustment.success = false;
        state.adjustment.error = null;
      })
      .addCase(adjustStock.fulfilled, (state) => {
        state.adjustment.loading = false;
        state.adjustment.success = true;
      })
      .addCase(adjustStock.rejected, (state, action) => {
        state.adjustment.loading = false;
        state.adjustment.error = action.payload;
      });

    // IMPORT STOCK
    builder
      .addCase(importStock.pending, (state) => {
        state.importState.loading = true;
        state.importState.success = false;
        state.importState.error = null;
        state.importState.data = null;
      })
      .addCase(importStock.fulfilled, (state, action) => {
        state.importState.loading = false;
        state.importState.success = true;
        state.importState.data = action.payload; // <--- ENREGISTREMENT DU RAPPORT DU SERVEUR
      })
      .addCase(importStock.rejected, (state, action) => {
        state.importState.loading = false;
        state.importState.error = action.payload;
      });

    builder
        .addCase(getStockHistory.pending, (state) => {
            state.history.loading = true;
        })
        .addCase(getStockHistory.fulfilled, (state, action) => {
            state.history.loading = false;
            state.history.data = action.payload;
        })
        .addCase(getStockHistory.rejected, (state, action) => {
            state.history.loading = false;
            state.history.error = action.payload;
        });
  },
});

export const { resetAdjustmentState, resetImportState, resetHistory } = stocksSlice.actions;
export default stocksSlice.reducer;